import React, { useEffect } from 'react'

const CreateSedeForm = ({formCreateSede, setFormCreateSede, showModalCreateSede}) => {

   useEffect(() => {
     if(!showModalCreateSede) {
        setFormCreateSede({});
     }
   }, [showModalCreateSede])  

   const handleFormChange = e => {
     const { name, value } = e.target;
     setFormCreateSede(prevState => ({ ...prevState, [name]: value }));
   }

  return (
    <div className='container'>
        <div className='row'>
            <div className='col-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <input name="descrizione" value={formCreateSede?.descrizione || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Indirizzo"/>
            </div>
        </div>
    </div>
  )
}

export default CreateSedeForm